import { useContext, useEffect, useState } from "react";
import InputRegister from "../../../layouts/ui/InputRegister";
import SelectInputWithSearch from "../../../layouts/ui/SelectInputWithSearch";
import { IoMdAdd } from "react-icons/io";
import { CiStar } from "react-icons/ci";
import { FaStar } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { candidateUpdateSkill } from "../../../services/Candidate Portal/Profile/skills/candidateUpdateSkill";
import { DataProvider } from "../../../store/ContextProvider";
import { createSkill } from '../../../services/Candidate Portal/Profile/skills/createSkill'
import { candidateDeleteSkill } from "../../../services/Candidate Portal/Profile/skills/candidateDeleteSkill";
import { fetchSkills } from "../../../services/Candidate Portal/Profile/skills/fetchSkills";
import { RxCross2 } from "react-icons/rx";
import { RiResetLeftLine } from "react-icons/ri";

// Create new skill object
const makeEmptySkill = (overrides = {}) => ({
    skills: overrides.skills ?? "",
    experience: overrides.experience ?? [{ month: "", year: "" }],
    lastUsed: overrides.lastUsed ?? "",
    version: overrides.version ?? "",
    isPrimary: overrides.isPrimary ?? false
});

export const Skill = ({ submitData, candidate }) => {
    const { BeURL ,showAlert } = useContext(DataProvider)
    const [skillList, setSkillList] = useState([]);
    const [topInput, setTopInput] = useState(makeEmptySkill());
    const [editingCardId, setEditingCardId] = useState(null);
    const [errors, setError] = useState({});
    const [skills, setSkills] = useState([])
    const [isAdding, setIsAdding] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const mandatory = {
        skills: true
    }

    const validator = (topInput, setError, mandatory) => {
        const newError = {};
        if (!topInput?.skills && mandatory.skills) {
            newError.skills = "Skill is required";
        }
        const year = topInput?.lastUsed?.toString().trim() || "";
        if (year && !/^\d{4}$/.test(year)) {
            newError.lastUsed = "Enter a valid 4-digit year";
        }
        const versionStr = String(topInput?.version ?? "").trim();
        if (versionStr !== "" && !/^\d+(\.\d+)?$/.test(versionStr)) {
            newError.version = "Version must be numeric (e.g., 1, 22.11)";
        } else {
            newError.version = "";
        }
        if (Array.isArray(topInput?.experience)) {
            topInput.experience.forEach((exp, idx) => {
                // Validate year
                if (exp.year !== "" && exp.year !== null && exp.year !== undefined) {
                    const monthNum = Number(exp.year);
                    if (monthNum < 0 || monthNum > 100) {
                        newError[`year`] = "Enter skill experience years";
                    }
                }
                if (exp.month !== "" && exp.month !== null && exp.month !== undefined) {
                    const monthNum = Number(exp.month);
                    if (monthNum < 0 || monthNum > 12) {
                        newError[`month`] = "Month must be between 0 and 12";
                    }
                }
            });
        }
        setError(newError);
        return Object.values(newError).filter(Boolean).length === 0
    };

    useEffect(() => {
        setSkillList(Array.isArray(candidate?.skills) ? candidate.skills : []);
    }, [candidate]);

    useEffect(() => {
        if (BeURL) {
            fetchSkills({ BeURL, setSkills })
        }
    }, [BeURL])

    const handleTopFieldChange = (field, value) => {
        setTopInput(prev => ({ ...prev, [field]: value }));
        validator({ ...topInput, [field]: value }, setError, mandatory);
    };

    const handleTopExperienceChange = (expIdx, field, value) => {
        setTopInput(prev => {
            const copy = { ...prev };
            copy.experience = (copy.experience || []).map((e, i) =>
                i === expIdx ? { ...e, [field]: value } : e
            );
            // Run validation immediately for the updated experience
            validator(copy, setError, mandatory);
            return copy;
        });
    };

        const addTopExperienceRow = () => {
            setTopInput((prev) => ({ ...prev, experience: [...(prev.experience || []), { month: "", year: "" }] }));
        };

        const removeTopExperienceRow = (index) => {
            setTopInput((prev) => ({ ...prev, experience: (prev.experience || []).filter((_, i) => i !== index) }));
        };

        const handleTopAdd = () => {
            if (!validator(topInput , setError , mandatory)) return;
            createSkill({ BeURL, skills: topInput, setSkillList, showAlert, handleTopClear, setIsAdding })
        };

        const handleTopClear = () => {
            setTopInput(makeEmptySkill());
            setEditingCardId(null);
        };

        const handleCardDelete = (id) => {
            candidateDeleteSkill({ BeURL, id, setSkillList, showAlert, handleTopClear, setIsDeleting })
        };

        const handleCardEdit = (id) => {
            if (!id) return;
            // find card by subdoc _id OR masterSkillId OR skill name
            const card = skillList.find(
                (c) =>
                    (c._id && String(c._id) === String(id)) ||
                    (c.masterSkillId && String(c.masterSkillId) === String(id)) ||
                    (c.skill && String(c.skill).trim().toLowerCase() === String(id).trim().toLowerCase())
            );

            if (!card) {
                console.warn("Card not found for id:", id);
                return;
            }
            // Map DB card -> topInput shape (use makeEmptySkill for defaults)
            const mapped = makeEmptySkill({
                skills: card.skill ?? "",
                experience: [
                    {
                        month: card.experience?.month != null ? String(card.experience.month) : "",
                        year: card.experience?.year != null ? String(card.experience.year) : "",
                    },
                ],
                lastUsed: card.lastUsed != null ? String(card.lastUsed) : "",
                version: card.version ?? "",
                isPrimary: !!card.isPrimary,
            });
            setTopInput(mapped);
            setEditingCardId(String(card._id));
        };


    const handleTopUpdate = async (id) => {
      if (!id) return;
      const card = skillList.find(
        (c) =>
          (c._id && String(c._id) === String(id)) ||
          (c.masterSkillId && String(c.masterSkillId) === String(id))
      );
      if (!card) {
        alert("Skill not found!");
        return;
      }
      let payload = {
        ...topInput,
        isPrimary: !card.isPrimary,
      };
        if (!BeURL || !id || !payload) {
            showAlert("Missing required data to update skill. Please try again.");
            return;
        }
        candidateUpdateSkill({ BeURL, id, topInput: payload, showAlert, setSkillList, handleTopClear, setIsUpdating});
    };

        useEffect(() => {
            if (submitData) {
                submitData(skillList);
            }
        }, [skillList, submitData]);

    return (
        <div className="py-4">
            <div className="border-2 rounded-xl p-4 bg-white shadow-sm">
                <div className="flex items-start justify-between">
                    <div>
                        <h4 className="text-sm font-semibold text-slate-800">{editingCardId ? 'Update' : 'Create'} Skill</h4>
                    </div>
                    <div className="ml-3 flex items-center gap-2">
                        {editingCardId ? (
                            <div className="flex gap-3">
                                <button onClick={handleTopClear} className="font-semibold underline text-primary-500  flex items-center justify-center cursor-pointer">
                                    <RiResetLeftLine />
                                </button>
                                <button title="delete" onClick={() => handleCardDelete(editingCardId)} className=" px-2 gap-1 cursor-pointer rounded-lg font-semibold border border-red-500 text-red-500 flex items-center justify-center" disabled={isDeleting}>
                                    <MdDeleteOutline size={20} />
                                    <span className="hidden md:block">{isDeleting ? "Deleting..." : "Delete"}</span>
                                </button>
                                <button title="update" onClick={() => handleTopUpdate(editingCardId)} className="rounded-lg gap-1 px-2 cursor-pointer  bg-primary-500 text-white flex items-center justify-center" disabled={isUpdating}>
                                    <FiEdit2  size={20} />
                                    <span className="hidden md:block">{isUpdating ? "Updating..." : "Update"}</span>
                                </button>
                            </div>
                        ) : (
                            <>
                                    <button onClick={handleTopClear} title="Clear" className="font-semibold underline text-primary-500  flex items-center justify-center cursor-pointer"><RiResetLeftLine /></button>
                                <button onClick={handleTopAdd} title="Add Skill" className=" px-4 rounded-lg bg-primary-400 text-white flex items-center justify-center shadow-md" disabled={isAdding}>
                                    <span className="">{isAdding ? "Adding..." : "Add"}</span>
                                    <IoMdAdd size={20} />
                                </button>

                            </>
                        )}
                    </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 md:gap-3 mt-4 items-end">
                    <SelectInputWithSearch
                        label="Title"
                        mandatory
                        value={topInput.skills}  
                        onChange={(e) => handleTopFieldChange("skills", e.target.value)}
                        placeholder="Skill"
                        options={skills}
                        className={"w-full capitalize"}
                        primary={true}
                        primaryChecked={topInput.isPrimary}                      
                        onPrimaryChange={(checked) => handleTopFieldChange("isPrimary", checked)}
                        error={errors?.skills ? errors.skills : ""}
                        border={true}
                    />

                    <InputRegister
                        label={"Experience"}
                        value={topInput.experience?.[0]?.year ?? ""}
                        onChange={(e) => handleTopExperienceChange(0, "year", e.target.value)}
                        placeholder="Years"
                        type="number"
                        className={"w-full"}
                        min="0"
                        max="100"
                        required
                        error={errors?.year ? errors?.year : ""}
                        border={true}
                    />
                    <InputRegister
                        value={topInput.experience?.[0]?.month || ""}
                        onChange={(e) => handleTopExperienceChange(0, "month", e.target.value)}
                        placeholder="Months"
                        type="number"
                        className="w-full"
                        min="0"
                        max="12"
                        required
                        error={errors?.month ? errors?.month : ""}
                        border={true}
                    />

                    <InputRegister
                        label={"Last used"}
                        value={topInput.lastUsed}
                        onChange={(e) => handleTopFieldChange("lastUsed", e.target.value)}
                        placeholder="Year"
                        type="tel"
                        className={"w-full"}
                        maxLength={4}
                        min="1900"
                        max="2099"
                        required
                        error={errors.lastUsed ? errors.lastUsed : ""}
                        border={true}                       
                    />
                    <InputRegister
                        label={"Version"}
                        value={topInput.version}
                        name="version"
                        onChange={(e) => handleTopFieldChange("version", e.target.value)}
                        placeholder="Version"
                        type="tel"
                        className={"w-full"}
                        error={errors.version ? errors.version : ""}
                        border={true}
                    />
                </div>
                {topInput.experience && topInput.experience.length > 1 && (
                    <div className="mt-3">
                        {topInput.experience.map((exp, i) => i === 0 ? null : (
                            <div key={i} className="flex gap-2 items-center mt-2">
                                <div className="w-28">
                                    <InputRegister value={exp.year} onChange={(e) => handleTopExperienceChange(i, "year", e.target.value)} placeholder="Years" />
                                </div>
                                <div className="w-28">
                                    <InputRegister value={exp.month} onChange={(e) => handleTopExperienceChange(i, "month", e.target.value)} placeholder="Months" />
                                </div>
                                <button onClick={() => removeTopExperienceRow(i)} className="px-2 py-1 rounded text-red-600">Remove</button>
                            </div>
                        ))}
                        <button onClick={addTopExperienceRow} className="mt-2 px-2 py-1 rounded bg-gray-100">+ Add Experience Row</button>
                    </div>
                )}
            </div>

            {/* Primary Skills */}
            <div className="mt-3 space-y-4 bg-white rounded-xl px-2 py-3 w-full">
                <p>Primary Skills</p>
                {
                    (Array.isArray(skillList) && skillList.length > 0 && skillList.filter(s => s.isPrimary).length > 0) ?
                        (
                            <div className="flex flex-wrap justify-stretch gap-3">
                                {
                                    skillList.filter(s => s.isPrimary)
                                        .map((card, idx) => (
                                            <div key={idx} className="bg-[#F6F6F6] flex rounded-lg py-1 px-4 gap-3 items-center relative">
                                                <div onClick={() => handleTopUpdate(card._id)} className="text-xl text-primary-100 cursor-pointer">
                                                    {card.isPrimary ? <FaStar /> : <CiStar />}
                                                </div>
                                                <div onClick={() => handleCardEdit(card.masterSkillId)} className="font-medium cursor-pointer">{card.skill || "-"}</div>
                                                <div onClick={() => handleCardDelete(card._id)} className="font-bold text-slate-800 cursor-pointer flex items-center justify-center mt-[2px]"><RxCross2 /></div>
                                            </div>
                                        ))
                                }
                            </div>
                        )
                        : (
                            <div className="text-sm text-slate-500 italic">
                                No Primary Skills added yet. add one using the form above!
                            </div>
                        )
                }
            </div>

            {/* Other Skills */}
            <div className="mt-3 space-y-4 bg-white rounded-xl px-2 py-3 w-full">
                <p>Skills</p>
                {
                    (Array.isArray(skillList) && skillList.length > 0) ?
                        (
                            <div className="flex flex-wrap justify-stretch gap-3">
                                {
                                    skillList.filter(s => !s.isPrimary)
                                        .map((card, idx) => (
                                            <div key={idx} className="bg-[#F6F6F6] flex rounded-lg py-1 px-4 gap-3 items-center relative">
                                                <div onClick={() => handleTopUpdate(card._id)} className="text-xl text-primary-100 cursor-pointer">
                                                    {card.isPrimary ? <FaStar /> : <CiStar />}
                                                </div>
                                                <div onClick={() => handleCardEdit(card.masterSkillId)} className="font-medium cursor-pointer">{card.skill || "-"}</div>
                                                <div onClick={() => handleCardDelete(card._id)} className="font-bold text-slate-800 cursor-pointer flex items-center justify-center mt-[2px]"><RxCross2 /></div>
                                            </div>
                                        ))
                                }
                            </div>
                        )
                        : (
                            <div className="text-sm text-slate-500 italic">
                                No Skills added yet. add one using the form above!
                            </div>
                        )
                }
            </div>
        </div>
    );
};
export default Skill;